import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import "flag-icons/css/flag-icons.min.css";
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './features/store';
import "./i18n";
import { HelmetProvider } from "react-helmet-async";
import { startHomePrefetch } from "./util/homePrefetch";

const root = ReactDOM.createRoot(document.getElementById('root'));
startHomePrefetch(); // L1 boot prefetch + L4 image preloads (global mode only)
root.render(
  <HelmetProvider>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </HelmetProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
